import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import * as notify from "../../../../../shared/notify";

import FactItem from "./fact-item";
import { isEmpty } from "lodash";
import classnames from "classnames";

const FactItemList = ({
    enableWarnings = false,
    isNewTemplateUsed,
    isNutrition,
    onResetDefaultNutritionValues,
    onResetDefaultVitaminsValues,
    ...props
}) => {
    const classNames = classnames("fact-items", {
        "horizontal-scroll": props.enableHorizontalScroller,
    });
    const isDietary = props.section === "dietary";

    // TODO: overcomplicated, refactor and simplify
    const updateField = (id, name, value, column) => {
        if (!value && name === "nutrient") {
            value = { value: Date.now(), text: "" };
        }

        const data = [...props.data];

        if (column !== false) {
            const facts = data[column].facts;
            const newFacts = facts.map((f) => {
                if (f.nutrient.value === id) {
                    if (name === "uom") {
                        f["quantity"] = value.value;
                        f[name] = value.uom;
                    } else {
                        f[name] = value;
                        f.nutrient.dataQualityIssue = undefined;
                    }
                }

                return f;
            });

            props.updateFacts(props.section, newFacts, column);
        } else {
            const [factsItem] = data;
            const nutrientIdList = factsItem.facts
                .map(({ nutrient }) => {
                    return {
                        code: nutrient.code,
                        value: nutrient.value,
                        text: nutrient.text,
                    };
                })
                .filter((nutrient) => (nutrient.code ? !!nutrient.code : !!nutrient.value));

            const hasExistingNutrient = nutrientIdList.some(
                (nutrient) =>
                    (nutrient.code && nutrient.code === value.code) ||
                    nutrient.value === value.value ||
                    (nutrient.text && nutrient.text === value.text)
            );

            if (hasExistingNutrient) {
                notify.error("Nutrient already exists");

                data.forEach(async (c, i) => {
                    const newFacts = c.facts.map((fact) => {
                        if (!fact.nutrient.text && fact.nutrient.value === id) {
                            return {
                                ...fact,
                                nutrient: {
                                    value: Date.now(),
                                    text: "",
                                },
                            };
                        }

                        return fact;
                    });

                    props.updateFacts(props.section, newFacts, i);
                });
            } else {
                data.forEach(async (c, i) => {
                    const newFacts = c.facts.map((fact) => {
                        if (fact.nutrient.value === id && !isEmpty(value)) {
                            return {
                                ...fact,
                                [name]: value,
                            };
                        }

                        return fact;
                    });

                    // apply order feature only for 'dietary' items in nutrition panel
                    props.updateFacts(props.section, newFacts, i, props.section !== "dietary" || !isNutrition);
                });
            }
        }
    };

    const removeNutrient = (id) => {
        const data = [...props.data];
        data.forEach(async (c, i) => {
            const newFacts = c.facts.filter((n) => n.nutrient.value !== id);
            props.updateFacts(props.section, newFacts, i);
        });
    };

    const width = { gridTemplateColumns: `75px 176px repeat(${props.columnCount * 2}, 1fr) 35px` };

    const getIdentifier = (item) => {
        // TODO: this is old grouping key, it's probably also broken on other panes
        if (!isNutrition) {
            return item.nutrient.value;
        }

        if (props.section === "dietary") {
            return item.nutrient.code ? item.nutrient.code : item.nutrient.value;
        }

        return item.nutrient.text ? item.nutrient.text : item.nutrient.value;
    };

    const getTooltipPosition = (itemsLength, index) => {
        if (itemsLength === 1) {
            return "right";
        }

        return itemsLength - 1 === index ? "top" : "";
    };

    const groupedFactItemMap = props.data
        .reduce((memo, d) => {
            memo.push(...d.facts);

            return memo;
        }, [])
        .reduce((map, item) => {
            const id = getIdentifier(item);

            const facts = map.get(id) || [];
            facts.push(item);
            map.set(id, facts);

            return map;
        }, new Map());
    const groupedFactItems = Array.from(groupedFactItemMap, ([, value]) => value);

    const factItems = groupedFactItems.map((item, i) => {
        const key = `fact_item_${props.section}_${i}of${groupedFactItems.length}`;

        return (
            <FactItem
                key={key}
                enableWarning={enableWarnings}
                factId={key}
                data={item}
                isNutrition={isNutrition}
                isDietary={isDietary}
                isNewTemplateUsed={isNewTemplateUsed}
                noteMarkList={props.noteMarkList}
                showDescription={props.showDescription}
                updateField={updateField}
                removeNutrient={removeNutrient}
                columnStyle={width}
                tooltipPosition={getTooltipPosition(groupedFactItems.length, i)}
            />
        );
    });

    const factHeaders = _.times(props.columnCount, (c) => {
        return (
            <Fragment key={`fact_item_header_${props.section}_${c}`}>
                <h3 style={{ minWidth: "150px" }}>Value</h3>
                <h3 style={{ minWidth: "150px" }}>% DV</h3>
            </Fragment>
        );
    });

    return (
        <div className={classNames}>
            <div
                className="fact-item"
                style={width}
            >
                <h3>Note Mark</h3>
                <h3>Item</h3>
                {factHeaders}
            </div>
            {factItems}
            <div className="flex justify-content-between">
                <button
                    name="newNutrient"
                    className="button -primary -small"
                    onClick={() => props.addFact(props.section)}
                >
                    <FontAwesomeIcon icon={faPlus} /> Nutrient
                </button>
                {isNutrition && (
                    <button
                        name="resetNutrients"
                        className="button -primary -small"
                        onClick={isDietary ? onResetDefaultNutritionValues : onResetDefaultVitaminsValues}
                    >
                        <FontAwesomeIcon
                            icon={faTrash}
                            className="m-r-8"
                        />
                        {isDietary ? "Clear Nutrient Values" : "Remove Vitamin/Mineral Rows"}
                    </button>
                )}
            </div>
        </div>
    );
};

export default FactItemList;
